import { motion } from 'framer-motion';

// Client logos with actual images
const clients = [
  { 
    name: 'SPSU', 
    logo: 'https://customer-assets.emergentagent.com/job_1961d3d3-b772-4517-a984-1bde18f8505c/artifacts/e5vitn7d_image.png',
    darkBg: true,
    large: false
  },
  { 
    name: 'MatiMitra Biochar', 
    logo: 'https://customer-assets.emergentagent.com/job_1961d3d3-b772-4517-a984-1bde18f8505c/artifacts/rancie3e_image.png',
    darkBg: false,
    large: true
  },
  { 
    name: 'GreenFeet', 
    logo: 'https://customer-assets.emergentagent.com/job_1961d3d3-b772-4517-a984-1bde18f8505c/artifacts/arjgo53z_image.png',
    darkBg: false,
    large: false
  },
  { 
    name: 'OasisBase', 
    logo: 'https://customer-assets.emergentagent.com/job_1961d3d3-b772-4517-a984-1bde18f8505c/artifacts/hsct4n1h_image.png',
    darkBg: false,
    large: true
  },
];

export const ClientLogos = () => {
  // Double the array for infinite scroll effect
  const doubledClients = [...clients, ...clients];

  return (
    <section 
      data-testid="client-logos-section"
      className="py-12 md:py-16 bg-white overflow-hidden"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 mb-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center"
        >
          <span className="font-sans text-sm font-semibold text-brand-green uppercase tracking-wider">
            Trusted By
          </span>
          <h2 className="font-serif text-2xl sm:text-3xl text-brand-dark mt-4">
            Our Clients
          </h2>
        </motion.div>
      </div>

      {/* Logo Carousel */}
      <div className="relative">
        <div className="flex animate-logo-scroll items-center">
          {doubledClients.map((client, index) => (
            <div
              key={index}
              className="flex-shrink-0 mx-8 md:mx-12"
              data-testid={`client-logo-${index}`}
            >
              <div className={`px-8 py-6 rounded-xl flex items-center justify-center h-32 w-56 ${
                client.darkBg ? 'bg-gray-900' : 'bg-white border border-gray-100'
              }`}>
                <img 
                  src={client.logo} 
                  alt={client.name}
                  className="max-h-20 max-w-full object-contain"
                />
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
